import { map } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { ReduxAction } from '../../reducers/reducerType'
import { Observable } from 'rxjs'
import { SET_ROLE } from '../../constants/actionTypes'
import { setAvailableFeaturesOnSetup } from '../../actions/setup/setupActions'

const setAvailableFeatures$ = (actions$: Observable<ReduxAction>) => actions$.pipe(
  ofType(SET_ROLE),
  map(() => setAvailableFeaturesOnSetup())
)

export default setAvailableFeatures$
